import { render, staticRenderFns } from "./contract-row.container.vue?vue&type=template&id=3887936e&scoped=true&lang=pug"
import script from "./contract-row.container.vue?vue&type=script&lang=ts"
export * from "./contract-row.container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3887936e",
  null
  
)

export default component.exports